import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { fontFamily } from "../../../../shared/styles";

export const ChartContainer = styled.div`
    width: 100%;
`;

export const xAxisTickTitle = css`
    ${fontFamily};
    margin-bottom: 2px;

    font-size: 12px;
    font-weight: 500;
    line-height: 16px;

    fill: ${Colors.Gray.V300};
`;

export const customLabel = css`
    ${fontFamily};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    fill: ${Colors.Black.V50};
`;

export const funnelMark = css`
    ${fontFamily};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    fill: ${Colors.WHITE};
`;

export const tickStyle = { fill: Colors.Gray.V300, fontSize: "11px", fontFamily: "Graphik", fontWeight: 400 };

const BAR_SPACING = 65;

export const CHART_WIDTH = 962;
export const BAR_WIDTH = 68;
export const POLYGON_FILL = "#E9EAEB";
export const LABEL_PADDING_LEFT = 8;

export const xAxisPoints = [0, 1, 2, 3, 4, 5, 6].map((item) => (CHART_WIDTH / 5) * item + BAR_SPACING);
